import { render, staticRenderFns } from "./UserEditTabPermission.vue?vue&type=template&id=4adaf066&"
import script from "./UserEditTabPermission.vue?vue&type=script&lang=js&"
export * from "./UserEditTabPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports